import {observable} from "mobx";
import {TextStruct} from './components/DrawText';
import NewsData from './store/news';

declare const require: any;

interface NewsJson {
    _id: string;
    link: string;
    cover: string;
    title: string;
    announce: TextStruct[];
    preview: TextStruct[];
    description: TextStruct[];
    tags: string[];
    date: string;
}

export class NewsStore {
    @observable news:News[] = [];
    
    constructor() {
        (NewsData).forEach(item => this.updateItem((item as NewsJson)));
    }
    
    private updateItem(item: NewsJson) {
        this.news.push(item);
    }
    
    public find() {
        return [...this.news];
    }
    
    public findById(id: string) {
        return this.news.filter(x => x._id === id).shift();
    }
    
    public findSimilar(item: News) {
        return this.news
            .filter(x => x._id != item._id)
            .filter(x => x.tags.filter(tag => item.tags.indexOf(tag) >= 0).length > 0);
    }
}

export class News {
    _id: string;
    
    @observable
    public title: string;
    
    @observable
    public cover: string;
    
    @observable
    public link: string;
    
    @observable
    public preview: TextStruct[];
    
    @observable
    public announce: TextStruct[];
    
    @observable
    public description: TextStruct[];
    
    @observable
    public tags: string[];
    
    @observable
    public date: string;
    
    constructor(data: NewsJson) {
        this._id = data._id;
        this.link = data.link;
        this.title = data.title;
        this.announce = data.announce;
        this.preview = data.preview;
        this.description = data.description;
        this.tags = data.tags || [];
        this.date = data.date;
        this.cover = data.cover;
    }
}

export const newsStore = new NewsStore();



/** WEBPACK FOOTER **
 ** ./src/store.tsx
 **/